import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { shotsData } from "../helpers/projectListData";
// import { gsap } from "gsap";
// import useParticles from "../utilities/particle";
import styles from "../styles/shots.css";
import { motion } from "framer-motion";

function ShotDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const shot = shotsData[id];
  // useParticles();
  return (
    <motion.div
      className="shotDetail"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
    >
      <a className="goBack" onClick={() => navigate(-1)}></a>
      <h2>{shot.name}</h2>
      <div className="contentSection">
        {shot.component}
        {/* <canvas className="slideThroughCanvas"></canvas> */}
      </div>
    </motion.div>
  );
}

export default ShotDetail;
